import React, { ForwardRefRenderFunction, PropsWithChildren } from 'react';
import { Divider, Stack, Typography } from '@mui/material';

interface CartProductSectionProps {
  title?: string,
}

const CartProductSection: ForwardRefRenderFunction<HTMLDivElement, PropsWithChildren<CartProductSectionProps>> = (
  { children, title },
  ref
) => {

  return (
    <div ref={ref}>
      <Stack direction="column" spacing={2} sx={{ }}>
        <Typography 
        variant="primaryFont" 
        letterSpacing="4px"
        fontSize={18}
        textTransform="uppercase">
          {title}
          </Typography>
        <Divider flexItem />
        <Stack
          direction="column"
          spacing={2}>
          {children}
        </Stack>
      </Stack>
    </div>
  );
};

const ForwardedCartProductSection = React.forwardRef(CartProductSection)

export default ForwardedCartProductSection;
